<div class="edit-watch-container">
  <h2>Editar Reloj</h2>
  <form [formGroup]="watchForm" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="fill">
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Marca</mat-label>
      <input matInput formControlName="brand">
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Precio</mat-label>
      <input matInput formControlName="price" type="number">
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Condición</mat-label>
      <mat-select formControlName="condition">
        <mat-option value="NEW">Nuevo</mat-option>
        <mat-option value="USED">Usado</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Estado del Mercado</mat-label>
      <input matInput formControlName="marketStatus">
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Descripción</mat-label>
      <textarea matInput formControlName="description"></textarea>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Imágenes</mat-label>
      <input matInput formControlName="images">
    </mat-form-field>

    <button mat-raised-button color="primary" type="submit">Guardar</button>
  </form>
</div>
